import axios from "axios";
import { message, notification } from "ant-design-vue"; /// es/notification

// 创建 axios 实例
const service = axios.create({
  baseURL: "/api", // api base_url
  timeout: 60000, // 请求超时时间
  headers: {
    "Content-Type": "application/json",
  },
});
const err = (error) => {
  if (error.response) {
    const data = error.response.data;

    if (error.response.status === 403) {
      console.log("服务器403啦，要重新登录！");
      notification.error({
        message: "Forbidden",
        description: data.message,
      });
    }
    if (error.response.status === 500) {
      if (data.message.length > 0) {
        message.error(data.message);
      }
    }
  }
  return Promise.reject(error);
};
service.interceptors.request.use((config) => {
  // const token = Vue.ls.get(ACCESS_TOKEN);
  const token = config.isDataSet ? process.env.VUE_APP_DATASET_TOKEN : process.env.VUE_APP_DIFY_TOKEN
  if (token) {
    config.headers["Authorization"] = "Bearer " + token;
  }
  return config;
}, err);
/**
 * response interceptor
 * 所有请求统一返回
 */
service.interceptors.response.use(async (response) => {
  if (response.request.responseType === "blob") {
    return response;
  }
  if (response.status === 404) {
    message.error(response.data.message || '请求失败');
    return Promise.reject(response);
  }
  return response.data;
}, err);
export default service;
